let previousValue = '';
let disabled = false;

/**
 * Disables body scrolling if disable argument is true by
 * setting overflow hidden propery. When scrolling is
 * enabled the previous value is set back to overflow
 *
 * @param {Object} options
 * @param {boolean} options.disable
 */
export const toggleBodyScrolling = (options) => {
    if (!disabled && options.disable === true) {
        previousValue = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        disabled = true;
    } else if (options.disable === false) {
        document.body.style.overflow = previousValue;
        disabled = false;
    }
};
